var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0.991 0H3.965C4.22783 0 4.47989 0.104409 4.66574 0.290257C4.85159 0.476106 4.956 0.72817 4.956 0.991V12.391C4.956 12.6538 4.85159 12.9059 4.66574 13.0917C4.47989 13.2776 4.22783 13.382 3.965 13.382H0.991C0.72817 13.382 0.476106 13.2776 0.290257 13.0917C0.104409 12.9059 0 12.6538 0 12.391L0 0.991C0 0.72817 0.104409 0.476106 0.290257 0.290257C0.476106 0.104409 0.72817 0 0.991 0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.92996 0H10.904C11.1668 0 11.4189 0.104409 11.6047 0.290257C11.7906 0.476106 11.895 0.72817 11.895 0.991V12.391C11.895 12.6538 11.7906 12.9059 11.6047 13.0917C11.4189 13.2776 11.1668 13.382 10.904 13.382H7.92996C7.66714 13.382 7.41507 13.2776 7.22922 13.0917C7.04337 12.9059 6.93896 12.6538 6.93896 12.391V0.991C6.93896 0.72817 7.04337 0.476106 7.22922 0.290257C7.41507 0.104409 7.66714 0 7.92996 0V0Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPause);
export default __webpack_public_path__ + "static/media/ico-pause.cfebd61b.svg";
export { ForwardRef as ReactComponent };